import { newRequestState } from "./state";
import dayjs from "dayjs";

export const newRequestPatchStateAction = (state, { data, ui }) => {
  if (!data) return { data: null, ui: { ...state.ui, ...ui } };

  return {
    ...state,
    data: {
      ...state.data,
      ...(data || {}),
    },
    ui: {
      ...state.ui,
      ...(ui || {}),
    },
  };
};

export const resetReCaptchaTokenAction = (state) => {
  return {
    ...state,
    data: {
      ...state.data,
      recaptcha: "",
    },
  };
};

export const onChangeAcceptTermAndConditionsAction = (state, status) => {
  return { ...state, ui: { ...state.ui, acceptTermAndConditions: status } };
};

export const planSelectedIsDirtyAction = (state, status) => {
  return { ...state, ui: { ...state.ui, planStepIsDirty: status } };
};

export const dispatchSelectedIsDirtyAction = (state, status) => {
  return { ...state, ui: { ...state.ui, dispatchStepIsDirty: status } };
};

export const updateBillInfoAction = (state, billInfo) => {
  return {
    ...state,
    data: {
      ...state.data,
      billInfo,
    },
  };
};

export const deleteBillInfoAction = (state, data) => {
  return {
    ...state,
    data: {
      ...state.data,
      billInfo: newRequestState.data.billInfo,
    },
  };
};

export const updatePaymentTypeAction = (state, paymentType) => {
  return {
    ...state,
    data: {
      ...state.data,
      paymentType,
    },
  };
};

export const setGeneralDataErrors = (state, errors = []) => {
  return {
    ...state,
    ui: {
      ...state.ui,
      generalDataStepErrors: Object.keys(errors).map((errorField) => {
        if (errorField === "email")
          return "El campo correo es inválido o no coincide con el de confirmación";
        if (errorField === "emailConfirm")
          return "El campo confirmación de correo es inválido o no coincide con el de correo";
        return errors[errorField];
      }),
    },
  };
};

export const setPlanDataErrorsAction = (state, errors = []) => {
  return {
    ...state,
    ui: {
      ...state.ui,
      planStepErrors: Object.keys(errors).map(
        (errorField) => errors[errorField]
      ),
    },
  };
};

export const setDispatchDataErrorsAction = (state, errors = []) => {
  return {
    ...state,
    ui: {
      ...state.ui,
      dispatchStepErrors: Object.keys(errors).map(
        (errorField) => errors[errorField]
      ),
    },
  };
};

export const setPatchGeneralData = (
  state,
  { billIssuerAvailable, ...data }
) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...data,
    },
  };
};

export const setGeneralData = (state, { billIssuerAvailable, ...data }) => {
  const { cotizador, factura } = data;
  const vehicleType =
    factura?.tipo_vehiculo?.replace(/_/g, " ") || state.data.vehicleType;
  const netAmount = factura?.monto_neto || state.data.netAmount;
  const anual = factura?.anual || state.data.anual;
  const dateOfIssue =
    (factura?.fecha_emision &&
      dayjs(factura.fecha_emision, "YYYY-MM-DD").toDate()) ||
    state.data.dateOfIssue;

  return {
    ...state,
    data: {
      ...state.data,
      ...data,
      anual,
      vehicleType,
      netAmount,
      dateOfIssue,
      plansAvailable: state.data.plansAvailable.map((plan) => ({
        ...plan,
        price: cotizador?.[plan.quoteKey],
      })),
    },
    ui: {
      ...state.ui,
      generalDataStepErrors: [],
    },
  };
};

export const setPlanDataAction = (state, data) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...data,
    },
    ui: {
      ...state.ui,
      planStepErrors: [],
    },
  };
};
export const setDispatchDataAction = (state, data) => {
  return {
    ...state,
    data: {
      ...state.data,
      dispatch: { ...data },
    },
    ui: {
      ...state.ui,
      dispatchStepErrors: [],
    },
  };
};

export const updateGeneralDataIsDirtyAction = (state, status) => {
  return { ...state, ui: { ...state.ui, generalDataStepIsDirty: status } };
};

export const disableIsDirtyAction = (state) => {
  return {
    ...state,
    ui: newRequestState.ui,
  };
};

export const paymentSelectedIsDirtyAction = (state, paymentStepIsDirty) => {
  return {
    ...state,
    ui: {
      ...state.ui,
      paymentStepIsDirty,
    },
  };
};

export const updatePlantTypeAction = (state, planSelected) => {
  return {
    ...state,
    data: {
      ...state.data,
      planSelected,
    },
  };
};

export const updateBillIssuerManagersAction = (state, managers = []) => {
  return {
    ...state,
    data: {
      ...state.data,
      managers,
    },
  };
};

export const updateBrandAndBillIssuerAction = (state, payload = []) => {
  return {
    ...state,
    data: {
      ...state.data,
      billIssuerAvailable: payload.map((item) => ({
        ...item,
        label: item.nombre,
        value: item.unique_id,
      })),
    },
  };
};
export const updateDispatchRegionDataAction = (state, payload = []) => {
  return {
    ...state,
    data: {
      ...state.data,
      dispatchRegionOptions: payload.map((item) => ({
        ...item,
        label: item.nombre,
        value: item.region_uuid,
      })),
    },
  };
};
